var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-delete",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    width: 26,
    height: 26,
    transform: "translate(-3 -3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_19",
    "data-name": "Exclusion 19",
    d: "M12.871,20H3.379a1.873,1.873,0,0,1-1.873-1.786L.991,7.392a.2.2,0,0,1,.2-.2H15.064a.2.2,0,0,1,.2.2l-.516,10.822A1.873,1.873,0,0,1,12.871,20ZM11.25,8.125a.625.625,0,0,0-.625.625v8.125a.625.625,0,1,0,1.25,0V8.75a.625.625,0,0,0-.625-.625Zm-3.125,0A.625.625,0,0,0,7.5,8.75v8.125a.625.625,0,1,0,1.25,0V8.75a.625.625,0,0,0-.625-.625ZM5,8.125a.625.625,0,0,0-.625.625v8.125a.625.625,0,1,0,1.25,0V8.75A.625.625,0,0,0,5,8.125ZM15.625,5.938h-15A.625.625,0,0,1,0,5.312V4.062A1.561,1.561,0,0,1,1.563,2.5H5V1.875A1.873,1.873,0,0,1,6.875,0h2.5A1.873,1.873,0,0,1,11.25,1.875V2.5h3.438A1.561,1.561,0,0,1,16.25,4.062v1.25a.625.625,0,0,1-.625.625ZM6.875,1.25a.626.626,0,0,0-.625.625V2.5H10V1.875a.626.626,0,0,0-.625-.625Z",
    transform: "translate(1.875)",
    fill: "#f5a350"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.ddc1ee7191dcc403db21034f04882f8e.svg";
export { ForwardRef as ReactComponent };